export const MODULES = Object.freeze({
    AUTH: "auth",
    PROFILE: "profile",
    COMPETITION: "competition",
    PATH: "path",
    UTILITY: "utility"
});